import Modal from "@mui/material/Modal";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import CloseIcon from '@mui/icons-material/Close';
import styled from "styled-components";
import { useState } from "react";
import DetailModal from "./DetailModal ";
import { PRIMARY,SECONDARY } from "../../const/colors";
const scrollbarStyle = `
  ::-webkit-scrollbar {
    width: 12px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #ffce05;
  }
  ::-webkit-scrollbar-track {
    background-color: #0c0e1e;
  }
`;
const DiscountModalContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 1rem 1.2rem;
  width: 75%;
  margin: 0 auto;
  background-color: #0c0e1e;
  border-radius:4px;
  border: 1px solid ${PRIMARY};
  box-shadow: 0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12);
  z-index: 9999;
  ${scrollbarStyle}
  .btnclose {
    border: none;
    border-radius:0px;
    background-color: #fff;
    color: ${SECONDARY};
    padding: 0.5rem;
    min-width: 50px;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out;
    svg {
      font-size: 2.5rem;
    }
    &:hover {
      background-color: #93291E;
      svg {
        color: #fff;
      }
    }

    @media screen and (max-width: 1600px) {
      padding: 0.1rem;
    }

    @media screen and (max-width: 768px) {
      display: inline-block;
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 1;
      min-width: auto;
      height: auto;
      line-height: normal;
    }
  }

  @media (max-width: 1200px) {
    width: 90%;
  }

  @media (max-width: 992px) {
    width: 95%;
  }

  @media (max-width: 768px) {
    width: 95%;
    padding: 0.5rem;
  }

  @media (max-width: 320px) {
    display: none;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom:0.8rem;
  padding:0 0.5rem;
`;

const Title = styled.h1`
  color: #ffce05;
  margin-bottom: 0;
`;

const DiscountCardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
  max-height: 70vh;
  overflow:hidden;
  overflow-y: auto;
  margin: 0 auto;
  background-color: #0c0e1e;
  text-align: center;
  scrollbar-color: #ffce05 #0c0e1e;
  scrollbar-width: thin;

  h2 {
    margin: 10px;
    color: white;
  }

  .css-bhp9pd-MuiPaper-root-MuiCard-root {
    background-color: #0c0e1e;
  }

  @media (max-width: 768px) {
    width: calc(100% - 20px);
  }
`;

const DiscountCard = styled(Card)`
  flex: 0 0 auto;
  width: 25%;
  padding: 0 8px;
  margin-top:16px;
  position:relative;
  transition: transform 0.3s ease 0s;
  cursor: pointer;
  ${scrollbarStyle}
  > .viewmore{
    position:absolute;
    bottom:0;
    left:0;
    width:100%;
    opacity:0;
    transition: transform 1s ease 0s;
    button{
      background-color: rgb(255, 206, 5);
      color: rgb(12, 14, 30);
      border: none;
      font-weight: 700;
      padding: 0.7rem 1.5rem;
      margin-bottom: 1rem;
      box-shadow: rgb(128, 103, 4) 0px 0px 14px;
      transition: transform 0.3s ease 0s;
      font-size: 16px;
      border-radius:0px;
      &:hover{
        transform: scale(1.1);
        transition: transform 0.3s ease 0s;
      }
    }
  }
  &:hover{
    transform: scale(1.05);
    transition: transform 0.3s ease 0s;
  }
  &:hover .viewmore{
    transition: transform 0.3s ease 0s;
    opacity:1;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
    .viewmore{
      opacity:1;
    }
  }
`;

const DiscountModal = ({ open, handleClose, discountArray }) => {
  const [selectedDiscount, setSelectedDiscount] = useState(null);

  const handleOpenImageModal = (discount) => {
    setSelectedDiscount(discount);
  };

  const handleCloseImageModal = () => {
    setSelectedDiscount(null);
  };
  return (
    <Modal open={open} onClose={handleClose}>
      <DiscountModalContainer>
        <TitleContainer>
          <Title>Bonos</Title>
          <Button className="btnclose" onClick={handleClose}><CloseIcon/></Button>
        </TitleContainer>

        <DiscountCardsContainer>
          {discountArray.map((discount, index) => (
            <DiscountCard key={index}>
              <CardMedia
                component="img"
                alt={discount.title}
                height="300px"
                image={discount.imageUrl}
              />
              <div className="viewmore">
                <Button onClick={() => handleOpenImageModal(discount)}>
                  <span>VER AHORA</span>
                </Button>
              </div>
            </DiscountCard>
          ))}
        </DiscountCardsContainer>

        {selectedDiscount && (
          <DetailModal
            open={Boolean(selectedDiscount)}
            handleClose={handleCloseImageModal}
            title={selectedDiscount.title}
            description={selectedDiscount.description}
            imageUrl={selectedDiscount.imageUrl}
          />
        )}
      </DiscountModalContainer>
    </Modal>
  );
};

export default DiscountModal;